import { FilterSelect, SearchInput, SortIcon } from "@marketplace/shared/ui";
import { getRouteApi } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useRecurringSortByOptions } from "../../hooks/use-recurring-sort-by-options";
import type { RecurringOrderListSortValue } from "../../types";

const route = getRouteApi("/recurring-orders/");

export const RecurringOrdersFilter = () => {
  const { q, sort } = route.useSearch();
  const navigate = route.useNavigate();
  const [search, setSearch] = useState(q ?? "");
  const { t } = useTranslation("order", {
    keyPrefix: "recurringOrderListPage"
  });
  const { t: tCommon } = useTranslation("common");
  const sortByOptions = useRecurringSortByOptions();

  const handleSearch = (value: string) => {
    setSearch(value);
  };

  const handleSortByChange = (value: RecurringOrderListSortValue) => {
    navigate({
      search: (prev) => ({
        ...prev,
        q: search,
        page: 1,
        sort: value
      })
    });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate({
        search: (prev) => ({
          ...prev,
          q: search,
          page: 1
        })
      });
    }, 300);

    return () => clearTimeout(timeout);
  }, [search, navigate]);

  return (
    <div className="flex justify-between items-center mb-6">
      <div>
        <SearchInput
          className="lg:w-[634px]"
          placeholder={t("searchPlaceholder")}
          value={search}
          onChange={handleSearch}
        />
      </div>
      <div className="flex gap-x-[14px]">
        <FilterSelect
          value={sort}
          label={tCommon("sortBy")}
          options={sortByOptions}
          width={179}
          icon={<SortIcon />}
          dropdownPosition="bottom-end"
          onChange={(v) => handleSortByChange(v as RecurringOrderListSortValue)}
        />
      </div>
    </div>
  );
};
